export const CONCLUSAO_FINALIZADA = 'CONCLUSAO_FINALIZADA';
export const conclusaoFinalizada = (conclusaoFinalizada) => ({
  type: CONCLUSAO_FINALIZADA,
  payload: {
    conclusaoFinalizada: conclusaoFinalizada,
  },
});




// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/conclusao/conclusao.action.js